export var sanitizeInputAgainstXSS = (term) => {
	return removeKeywordsCaseInsensitive((null != term && term.length > 0 ? term.trim() : ''));
}


var removeKeywordsCaseInsensitive = (originalTerm) => {
	var sanitizedTerm = '';
	var originalTermArray = originalTerm.split(' ');
	
	var continueLooping = true;
	while(continueLooping){
		sanitizedTerm = loopOverTerm(originalTermArray);
		if(sanitizedTerm.length == originalTerm.length){
			continueLooping = false;
		}else{
			originalTerm = sanitizedTerm;
			originalTermArray = sanitizedTerm.split(' ');
		} 
	}
	return sanitizedTerm;
}

var loopOverTerm = (orgTermArray) => {
	var sanitizedTerm = '';
	
	for(var i = 0; i < orgTermArray.length; i++){
		var thisTerm = sanitizeTermAgainstXSS(orgTermArray[i].toLowerCase());

		if(thisTerm.length > 0 && thisTerm.length == orgTermArray[i].length){
			sanitizedTerm = (sanitizedTerm.length > 0 ? sanitizedTerm + ' ' + orgTermArray[i] : orgTermArray[i]);
		}else if(thisTerm.length > 0){
			sanitizedTerm = (sanitizedTerm.length > 0 ? sanitizedTerm + ' ' + thisTerm : thisTerm);
		}
	}
	return sanitizedTerm;
}

var sanitizeTermAgainstXSS = (term) => {
	return term.trim()
	//-ext added
	.split('>').join('').split('}').join('')
	.split('&lt;').join('').split('alert(').join('')
	.split('alert').join('').split('prompts').join('')
	.split('prompt').join('').split('javascript').join('')
	.split('document.write(').join('').split('document.execcommand(').join('')
	.split('confirm(').join('').split('eval(').join('')
	//commerce supplied
	.split('&amp;#106;&amp;#97;&amp;#118;&amp;#97;&amp;#115;&amp;#99;&amp;#114;&amp;#105;&amp;#112;&amp;#116;').join('')
	.split('&amp;#x6a;&amp;#x61;&amp;#x76;&amp;#x61;&amp;#x73;&amp;#x63;&amp;#x72;&amp;#x69;&amp;#x70;&amp;#x74;').join('')
	.split('&lt;%').join('').split('&amp;lt;%').join('').split('&amp;lt;script').join('');
}